import { isString } from "radashi";

class ReadFileError extends Error {
  constructor(
    readonly reason: "abort" | "error",
    readonly event: ProgressEvent<FileReader>,
  ) {
    super();
  }
}

export function downloadFile(blobOrHref: Blob | string, filename: string) {
  const url = isString(blobOrHref)
    ? blobOrHref
    : URL.createObjectURL(blobOrHref);
  const element = document.createElement("a");
  element.href = url;
  element.download = filename;
  element.click();

  if (!isString(blobOrHref)) {
    URL.revokeObjectURL(url);
  }
}

export function isAbortError(error: unknown): error is ReadFileError {
  return error instanceof ReadFileError && error.reason === "abort";
}

export function isReadFileError(error: unknown): error is ReadFileError {
  return error instanceof ReadFileError;
}

export function readFileAsArrayBuffer(
  file: File,
): Promise<ArrayBuffer | string | null> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsArrayBuffer(file);

    reader.onabort = (e) => {
      reject(new ReadFileError("abort", e));
    };

    reader.onerror = (e) => {
      reject(new ReadFileError("error", e));
    };

    reader.onload = () => {
      resolve(reader.result);
    };
  });
}
